import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Badge } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import {
  CLIENT_DISTRIBUTOR_PRODUCT,
  CLIENT_DISTRIBUTOR_PRODUCT_ATTRIBUTE_PROPAGATION_FLAG,
} from 'lib/networking/endpoints';
import { ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS } from 'lib/enums/AttributePropagationFlagTypeEnum';
import { CUT_DRY_CLIENT_ID } from 'lib/constants';
import EditableFlagBadge from 'components/global_products/detail_view/EditableFlagBadge';
import { IMAGE_FLAG_TYPES_OPTIONS } from 'lib/enums/ImageFlagTypeEnum';
import { ProductType } from 'lib/enums/ProductType';
import { SwalToast } from 'lib/utils/toast';
import useGet from 'lib/hooks/useGet';
import usePost from 'lib/hooks/usePost';

const FlagComponent = ({ product, productType, onFlagUpdate }) => {
  const { data: { data: clientDistributorProduct } = {} } = useGet(
    CLIENT_DISTRIBUTOR_PRODUCT,
    {
      product_id: product.id,
      client_id: CUT_DRY_CLIENT_ID,
    },
    productType != ProductType.DISTRIBUTOR,
  );

  const [imageFlag, setImageFlag] = useState(null);
  const [attributeFlag, setAttributeFlag] = useState(null);

  useEffect(() => {
    setImageFlag(clientDistributorProduct?.image_flag || null);
    setAttributeFlag(clientDistributorProduct?.attribute_propagation_flag || null);
  }, [clientDistributorProduct]);

  const onFlagUpdateSuccess = () => {
    SwalToast('success', `Successfully Updated`);
    onFlagUpdate && onFlagUpdate();
  };
  const { postData: updateImageFlag } = usePost(
    CLIENT_DISTRIBUTOR_PRODUCT,
    onFlagUpdateSuccess,
    () => SwalToast('error', `Error Occurred`),
  );
  const { postData: updateAttributeFlag } = usePost(
    CLIENT_DISTRIBUTOR_PRODUCT_ATTRIBUTE_PROPAGATION_FLAG,
    onFlagUpdateSuccess,
    () => SwalToast('error', `Error Occurred`),
  );

  const handleImageFlagSave = value => {
    const previous = imageFlag;
    setImageFlag(value);
    updateImageFlag({
      client_id: CUT_DRY_CLIENT_ID,
      product_id: product.id,
      image_flag: value,
    }).then(res => {
      if (res instanceof Error) {
        setImageFlag(previous);
      }
    });
  };

  const handleAttributeFlagSave = value => {
    const previous = attributeFlag;
    setAttributeFlag(value);
    updateAttributeFlag({
      client_id: CUT_DRY_CLIENT_ID,
      product_id: product.id,
      attribute_propagation_flag: value,
    }).then(res => {
      if (res instanceof Error) {
        setAttributeFlag(previous);
      }
    });
  };

  if (productType !== ProductType.DISTRIBUTOR) {
    return null;
  }

  return (
    <tbody>
      <tr>
        <td className="pr-4">Image flag</td>
        <td>
          <OverlayTrigger placement="top" overlay={<Tooltip>Global level flag</Tooltip>}>
            <Badge variant="success">G - {product.global_vendor.image_flag}</Badge>
          </OverlayTrigger>
        </td>
        <td>
          <EditableFlagBadge
            value={imageFlag}
            options={IMAGE_FLAG_TYPES_OPTIONS}
            label="P"
            tooltip="Product level flag"
            onSave={handleImageFlagSave}
          />
        </td>
      </tr>
      <tr>
        <td>Attribute flag</td>
        <td>
          <OverlayTrigger placement="top" overlay={<Tooltip>Global level flag</Tooltip>}>
            <Badge variant="success">G - {product.global_vendor.attribute_propagation_flag}</Badge>
          </OverlayTrigger>
        </td>
        <td>
          <EditableFlagBadge
            value={attributeFlag}
            options={ATTRIBUTE_PROPAGATION_FLAG_TYPES_OPTIONS}
            label="P"
            tooltip="Product level flag"
            onSave={handleAttributeFlagSave}
          />
        </td>
      </tr>
    </tbody>
  );
};

FlagComponent.propTypes = {
  product: PropTypes.object.isRequired,
  productType: PropTypes.string.isRequired,
  onFlagUpdate: PropTypes.func,
};

export default FlagComponent;
